import { render } from "./DialogReservationExpired.vue?vue&type=template&id=2d5293ce"
import script from "./DialogReservationExpired.vue?vue&type=script&lang=js"
export * from "./DialogReservationExpired.vue?vue&type=script&lang=js"
script.render = render

export default script